import { CardServiceInstructionApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const CardServiceInstructionApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <CardServiceInstructionApplication isEdit={isEdit} isCopy={isCopy}/>
);
